import { render, staticRenderFns } from "./ResultViewContent.vue?vue&type=template&id=f731cdf4&scoped=true"
import script from "./ResultViewContent.vue?vue&type=script&lang=ts"
export * from "./ResultViewContent.vue?vue&type=script&lang=ts"
import style0 from "./ResultViewContent.vue?vue&type=style&index=0&id=f731cdf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f731cdf4",
  null
  
)

export default component.exports